import api from "@services/axios/apiManager";

/**
 * 打 GET /coupons/summary 觸發後端 lazyIssueOnPlatformUse：
 * 客戶「使用平台」時，補發有上限（issue_limit）的優惠券給既有客戶（先到先得）。
 *
 * 帶上 X-Context（目前所在帳戶/瓦斯行 context）讓後端解析出 supplier_id，
 * 這樣不只平台券、連「該瓦斯行自家的限量券」也會一起補發。
 *
 * 補發是後端副作用；前端在抓 /coupons 清單「之前」await 它，讓剛補發的券能立刻出現。
 * 補發失敗不應阻斷抓券流程（下次進訂購頁會再觸發一次），故吞掉錯誤只 log。
 */
export const triggerCouponLazyIssue = async (jwtToken: string, xContext?: string): Promise<void> => {
  if (!jwtToken) return;
  try {
    await api.get("/app-api/coupons/summary", {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
        ...(xContext ? { "X-Context": xContext } : {}),
      },
    });
  } catch (error) {
    console.error("triggerCouponLazyIssue error", error);
  }
};
